<template>
    <section
        role="alert"
        class="bank__info"
    >
        <p>
            {{ $t("bank.info") }}
        </p>
    </section>
</template>
<script>
export default {
    name: "BankInfo",
};
</script>
<style lang="scss" scoped>
.bank__info {
  width: 100%;
  
  background: #FFFDFB;
  border: 1px solid rgba(108, 108, 108, 0.15);
  box-sizing: border-box;
  border-radius: 4px;

  padding: 14px;
  color: $black-3;

  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 20px;
  text-align: center;
}
</style>